import Vue from 'vue'

// axios
import axios from 'axios'

// const endpoint = localStorage.getItem('wallet_endpoint')
const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  // baseURL: 'https://some-domain.com/api/',
  baseURL: 'https://walletapi.ufobet.net/api',
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
})

Vue.prototype.$http = axiosIns

export default axiosIns
